import { render, staticRenderFns } from "./sendTestMediaConfirm.vue?vue&type=template&id=97dbac04&scoped=true"
import script from "./sendTestMediaConfirm.vue?vue&type=script&lang=js"
export * from "./sendTestMediaConfirm.vue?vue&type=script&lang=js"
import style0 from "./sendTestMediaConfirm.vue?vue&type=style&index=0&id=97dbac04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dbac04",
  null
  
)

export default component.exports